import { motion } from 'framer-motion'
import { useOnboardingStore } from '../store/onboardingStore'
import { Button } from '../components/Button'

/**
 * First-screen "stop-scroll" hook for cold paid Meta traffic. Mirrors the ad
 * creative tone (interruption/curiosity), pays off the ad click immediately by
 * pointing toward the demo, and avoids the "problem recap" feel of PainPoints
 * which can feel like the visitor wasted their click.
 *
 * Used only on the meta-short variant. Organic still goes through PainPoints.
 */
export function HookStep() {
  const { goNext } = useOnboardingStore()

  return (
    <div className="min-h-dvh flex flex-col bg-white">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md text-center"
        >
          <motion.button
            type="button"
            onClick={() => goNext()}
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: 'spring' }}
            whileTap={{ scale: 0.98 }}
            className="relative rounded-3xl overflow-hidden mb-8 shadow-xl w-full block cursor-pointer"
            aria-label="See how it works"
          >
            <img
              src="/images/demo-breakfast.jpeg"
              alt="A breakfast plate ready to be scanned"
              className="w-full aspect-[4/3] object-cover pointer-events-none"
            />
            <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur px-3 py-2 rounded-xl shadow-sm flex items-center gap-2 pointer-events-none">
              <span className="text-base">📸</span>
              <span className="text-xs font-semibold text-gray-800">Tap to scan</span>
            </div>
          </motion.button>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Stop guessing what you can eat.
          </h1>
          <p className="text-lg text-gray-600 mb-10 leading-relaxed">
            KidneyPal scans any meal and tells you instantly if it's safe for your kidneys.
            See it work on a real breakfast in 5 seconds.
          </p>

          <Button onClick={() => goNext()}>
            <span className="flex items-center justify-center gap-2">
              See how it works
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
          </Button>

          <p className="text-xs text-gray-400 mt-6">
            Free demo · No signup needed · 30 seconds
          </p>
        </motion.div>
      </div>
    </div>
  )
}
